import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateProviderConfigFormContext,
  CreateProviderConfigFormState,
  createProviderConfigFormStateDefault,
  createProviderConfigSchemaDefault,
} from '@Forms/providers/CreateProviderConfigFormContext';

export const CreateProviderConfigFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateProviderConfigFormState>>>(
    createProviderConfigSchemaDefault
  );
  const methods = useForm({
    defaultValues: createProviderConfigFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateProviderConfigFormContext.Provider value={value}>
      {children}
    </CreateProviderConfigFormContext.Provider>
  );
};
